import { render } from "./DispTable.vue?vue&type=template&id=119eab5c&scoped=true"
import script from "./DispTable.vue?vue&type=script&lang=js"
export * from "./DispTable.vue?vue&type=script&lang=js"

import "./DispTable.vue?vue&type=style&index=0&id=119eab5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119eab5c"]])

export default __exports__